import localScaleManager from "../../../helpers/LocalScaleManager";
import { WebSocketManager } from "../../../helpers/webSocketManager";
import router from "../../../../../routes";
import MenuBtn from "./menuBtn";
import { tweenConfigs } from "../../../helpers/tweensConfigs";

export default class Menu {
  constructor(scene) {
    this.scene = scene;
    this.toggleButton = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "menu-btn")
      .setOrigin(0);
    this.toggleButton.setInteractive({ cursor: "pointer" });
    this.toggleButton.on("pointerdown", this.onButtonClick, this);
    this.closeButton = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "menu-close")
      .setDepth(111);
    this.closeButton.setInteractive({ cursor: "pointer" });
    this.closeButton.on("pointerdown", this.overlayOnClick, this);

    this.menuGroup = this.scene.add.group();
    this.menu = this.scene.add.group();
    this.menuMargin = 0;
    this.menuIsShowing = false;

    this.allowMenuToggle = true;

    this.header = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "menu-header")
      .setOrigin(0)
      .setDepth(110);

    this.lobbyBtn = new MenuBtn(this.scene, "lobby", 0);
    this.counterTimeBtn = new MenuBtn(this.scene, "counter-time", 1);
    this.sitOutBtn = new MenuBtn(this.scene, "sit-out", 2);
    this.leaveSeatBtn = new MenuBtn(this.scene, "leave-seat", 3);
    this.tableSettingBtn = new MenuBtn(this.scene, "table-setting", 4);
    this.exitTableBtn = new MenuBtn(this.scene, "exit-table", 5);

    this.lobbyBtn.on("pointerdown", this.lobbyOnClick, this);
    this.tableSettingBtn.on("pointerdown", this.tableSettingOnClick, this);
    this.sitOutBtn.on("pointerdown", this.sitOutOnClick, this);
    this.counterTimeBtn.on("pointerdown", this.counterTimeOnClick, this);
    this.leaveSeatBtn.on("pointerdown", this.leaveSeatOnClick, this);
    this.exitTableBtn.on("pointerdown", this.exitTableOnClick, this);

    this.menuGroup.addMultiple([
      this.lobbyBtn,
      this.counterTimeBtn,
      this.sitOutBtn,
      this.leaveSeatBtn,
      this.tableSettingBtn,
      this.exitTableBtn,
    ]);

    this.menu.addMultiple([
      this.header,
      this.closeButton,
      ...this.menuGroup.getChildren(),
    ]);
    this.overlay = this.scene.add.rectangle(0, 0, 0, 0, 0x000000);
    this.overlay.setAlpha(0.01).setVisible(false);
    this.overlay.setDepth(100);
    this.tweenDeltaX = 0;

    this.registryName = "showTableSetting";
    this.scene.registry.set(this.registryName, false);
  }
  lobbyOnClick() {
    if (this.scene.getVisitedTableGame().getClubId()) {
      router.push(`/lobby/${this.scene.getVisitedTableGame().getClubId()}`);
    } else router.push("/home");
  }
  async tableSettingOnClick() {
    await this.overlayOnClick();
    this.scene.changeObjectsInteractivity(false);
    this.scene.registry.set(this.registryName, true);
  }
  sitOutOnClick() {
    // this.overlayOnClick();
    // this.scene
    //   .getVisitedTable()
    //   .modalsManager.notice.show("Are You Sure You Want to Sit Out?", () => {
    //     this.sitOutBtn.disableInteractive();
    //     WebSocketManager.emitEvent(
    //       { tableId: this.scene.getVisitedTable().tableInfo.id },
    //       "poker.client-push.sit-out"
    //     )
    //       .then((_) => {
    //         this.sitOutBtn.setInteractive();
    //       })
    //       .catch((_) => {
    //         this.sitOutBtn.setInteractive();
    //       });
    //   });
    const visitedTable = this.scene.getVisitedTable();
    this.overlayOnClick();
    this.scene.Swal.fire({
      title: "Are You Sure You Want to Sit Out?",
      // html: hTML,
      showCancelButton: true,
      confirmButtonText: "OK",
      customClass: {
        title: "sweet-alert-title",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.sitOutBtn.disableInteractive();
        WebSocketManager.emitEvent(
          { tableId: visitedTable.tableInfo.id },
          "poker.client-push.sit-out"
        )
          .then((_) => {
            this.sitOutBtn.setInteractive();
          })
          .catch((_) => {
            this.sitOutBtn.setInteractive();
          });
      }
    });
  }
  counterTimeOnClick() {
    this.counterTimeBtn.disableInteractive();
    WebSocketManager.emitEvent(
      { tableId: this.scene.getVisitedTable().tableInfo.id },
      "poker.client-push.counter-time"
    )
      .then((res) => {
        this.counterTimeBtn.setInteractive();
        if (this.scene.alertify)
          this.scene.alertify.typeSuccess("Counter time was started.");
        this.counterTimeBtn.disable();
        this.overlayOnClick();
      })
      .catch((_) => {
        this.counterTimeBtn.setInteractive();
      });
  }
  leaveSeatOnClick() {
    this.overlayOnClick();
    const visitedTable = this.scene.getVisitedTable();
    if (
      visitedTable.gameState.playerInfo.state === "SitOut" ||
      visitedTable.gameState.playerInfo.state === "WaitToJoin" ||
      visitedTable.gameState.playerInfo.state === "WaitToStart" ||
      visitedTable.gameState.playerInfo.state === "AllIn" ||
      visitedTable.gameState.state === "End" ||
      visitedTable.gameState.state === "Idle" ||
      visitedTable.gameState.state === "preEnd"
    ) {
      this.leaveSeatBtn.disableInteractive();
      WebSocketManager.emitEvent(
        { tableId: visitedTable.tableInfo.id },
        "poker.client-push.leave"
      )
        .then((_) => {
          this.leaveSeatBtn.setInteractive();
        })
        .catch((_) => {
          this.leaveSeatBtn.setInteractive();
        });
    } else {
      // visitedTable.modalsManager.notice.show(
      //   "Are You Sure You Want To Leave The Seat?",
      //   () => {
      //     this.leaveSeatBtn.disableInteractive();
      //     WebSocketManager.emitEvent(
      //       { tableId: visitedTable.tableInfo.id },
      //       "poker.client-push.leave"
      //     )
      //       .then((_) => {
      //         this.leaveSeatBtn.setInteractive();
      //       })
      //       .catch((_) => {
      //         this.leaveSeatBtn.setInteractive();
      //       });
      //   }
      // );

      this.scene.Swal.fire({
        title: "Are You Sure You Want To Leave The Seat?",
        showCancelButton: true,
        confirmButtonText: "OK",
        customClass: {
          title: "sweet-alert-title",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.leaveSeatBtn.disableInteractive();
          WebSocketManager.emitEvent(
            { tableId: visitedTable.tableInfo.id },
            "poker.client-push.leave"
          )
            .then((_) => {
              this.leaveSeatBtn.setInteractive();
            })
            .catch((_) => {
              this.leaveSeatBtn.setInteractive();
            });
        }
      });
    }
  }
  exitTableOnClick() {
    this.overlayOnClick();
    let hTML = "";
    const visitedTable = this.scene.getVisitedTable();
    const title = `Are You Sure You Want to Leave the ${
      visitedTable.isTournamentTable() ? "Tournament" : "Table"
    } ?`;
    if (visitedTable.gameState.playerInfo) {
      if (!visitedTable.isTournamentTable()) {
        hTML = `${visitedTable.tableInfo.tableType}<br>
        ${visitedTable.tableInfo.name} - ${
          visitedTable.tableInfo.smallBlinds
        } / ${visitedTable.tableInfo.bigBlinds}<br>
        Cash-out Amount ${visitedTable.gameState.playerInfo.balance.toLocaleString()}`;
      }
      this.scene.Swal.fire({
        title: title,
        html: hTML,
        showCancelButton: true,
        confirmButtonText: "OK",
        customClass: {
          title: "sweet-alert-title",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.exitTableBtn.disableInteractive();
          WebSocketManager.emitEvent(
            { tableId: visitedTable.tableInfo.id },
            "poker.client-push.observe-not"
          )
            .then((_) => {
              this.exitTableBtn.setInteractive();
              this.scene.alertify.dismissAll();
              this.scene.destroyTableGame(visitedTable.tableInfo.id);
            })
            .catch((_) => {
              this.exitTableBtn.setInteractive();
            });
        }
      });
    } else {
      this.exitTableBtn.disableInteractive();
      WebSocketManager.emitEvent(
        { tableId: visitedTable.tableInfo.id },
        "poker.client-push.observe-not"
      )
        .then((_) => {
          this.exitTableBtn.setInteractive();
          this.scene.alertify.dismissAll();
          this.scene.destroyTableGame(visitedTable.tableInfo.id);
        })
        .catch((_) => {
          this.exitTableBtn.setInteractive();
        });
    }
  }
  onButtonClick() {
    if (this.allowMenuToggle && this.scene.isSceneObjectsInteractive) {
      this.allowMenuToggle = false;
      /* In every show menu, positions should be updated since the visited table might be changed, and we have only one menu.*/
      this.updatePositions();
      this.updateDisplay();
      this.showOverlay();
      this.menuIsShowing = true;

      // this.scene.tweens.add({
      //     targets: this.menuGroup.getChildren(),
      //     duration: 300,
      //     ease: "Linear",
      //     x: `+=${this.tweenDeltaX}`,
      //     alpha: {
      //         delay: 270,
      //         value: 1,
      //         duration: 30,
      //         ease: 'Power2',
      //         yoyo: false
      //     },
      //     yoyo: true,
      //     onComplete: () => {
      //         this.allowMenuToggle = true;
      //     }
      // })
      let tweenCounter = 0;
      this.menu.children.iterate(function (child, i) {
        this.scene.tweens.add({
          targets: child,
          x: `+=${this.tweenDeltaX}`,
          ease: tweenConfigs.sideMenu.show.ease,
          duration: tweenConfigs.sideMenu.show.duration,
          // delay: i * 70,
          yoyo: true,
          alpha: {
            // delay: 270 + i * 70,
            delay: tweenConfigs.sideMenu.show.duration - 30,
            value: 1,
            duration: 30,
            ease: "Power2",
            yoyo: false,
          },
          onComplete: () => {
            tweenCounter++;
            if (tweenCounter === this.menuGroup.getChildren().length - 1) {
              this.allowMenuToggle = true;
            }
          },
        });
      }, this);
    }
  }
  showOverlay() {
    if (!this.overlay.visible) this.overlay.setVisible(true);
  }
  async overlayOnClick() {
    return new Promise((resolve) => {
      if (this.allowMenuToggle) {
        this.allowMenuToggle = false;
        this.menuIsShowing = false;
        this.hideOverlay();
        this.scene.tweens.add({
          targets: this.menu.getChildren(),
          duration: tweenConfigs.sideMenu.hide.duration,
          ease: tweenConfigs.sideMenu.hide.ease,
          alpha: {
            value: 0,
            duration: 100,
            ease: "Power2",
            yoyo: false,
          },
          x: `+=${this.tweenDeltaX}`,
          yoyo: true,
          onComplete: () => {
            this.allowMenuToggle = true;
            resolve();
          },
        });
      }
    });
  }
  hideOverlay() {
    if (this.overlay.visible) this.overlay.setVisible(false);
  }
  changePosition(x) {
    const initPosition =
      this.scene.gameWidth - this.menuMargin - this.toggleButton.displayWidth;
    this.toggleButton.setX(x + initPosition);
  }
  scrollTo(positionX) {
    const initPosition =
      this.scene.gameWidth - this.menuMargin - this.toggleButton.displayWidth;
    this.scene.tweens.add({
      targets: this.toggleButton,
      x: initPosition + positionX,
      duration: tweenConfigs.camera.duration,
      ease: tweenConfigs.camera.ease,
    });
  }
  /*
   * Are buttons disabled or not?
   */
  updateDisplay() {
    this.enableAllButtons();
    const visitedTable = this.scene.getVisitedTable();
    if (visitedTable.gameState.playerInfo) {
      /* The selfPlayer has sat. */
      const playerInfo = visitedTable.gameState.playerInfo;
      if (playerInfo.state === "SitOut") {
        this.sitOutBtn.disable();
        this.counterTimeBtn.disable();
      }
      if (
        visitedTable.gameState.otherPlayers.length === 0 ||
        playerInfo.counterTimeActivated ||
        playerInfo.counterTimePassed ||
        playerInfo.totalWinLoss <= 0
      ) {
        this.counterTimeBtn.disable();
      }
    } else {
      /*The selfPlayer has not sat.*/
      this.sitOutBtn.disable();
      this.counterTimeBtn.disable();
      this.leaveSeatBtn.disable();
      this.counterTimeBtn.disable();
    }
    if (visitedTable.tableInfo.counterTime === 0) {
      this.counterTimeBtn.disable();
    }
  }
  enableAllButtons() {
    this.menuGroup.children.iterate((child) => {
      child.enable();
    }, this);
  }
  /**
   * @param width {number} table
   * @param height {number} table
   */
  positionControls(width, height) {
    let btnSize = Math.min(width / 15, height / 15);
    localScaleManager.scaleSprite(
      this.toggleButton,
      btnSize,
      btnSize,
      0,
      1,
      true
    );

    this.initX = this.scene.gameWidth * this.scene.getVisitedTableGameIndex();
    this.menuMargin = this.toggleButton.displayWidth / 2;
    this.toggleButton.setPosition(
      this.initX +
        this.scene.gameWidth -
        this.menuMargin -
        this.toggleButton.displayWidth,
      this.menuMargin
    );
    const headerSize = width / 1.7;
    localScaleManager.scaleSprite(
      this.header,
      headerSize,
      headerSize,
      0,
      1,
      true
    );
    localScaleManager.scaleSprite(
      this.closeButton,
      this.header.displayHeight * 0.45,
      this.header.displayHeight * 0.45,
      0,
      1,
      true
    );
    this.header.setPosition(
      this.initX -
        this.menuMargin +
        this.scene.gameWidth -
        this.header.displayWidth,
      this.menuMargin
    );
    this.closeButton.setPosition(
      this.header.x + this.header.displayWidth - this.header.displayHeight / 2,
      this.header.y + this.header.displayHeight / 2
    );

    let preChild;
    this.menuGroup.children.iterate((child) => {
      if (preChild)
        child.positionControls(
          width,
          height,
          this.header.x,
          preChild.y + preChild.displayHeight * 0.99
        );
      else
        child.positionControls(
          width,
          height,
          this.header.x,
          this.header.y + this.header.displayHeight * 0.99
        );
      preChild = child;
    }, this);

    this.tweenDeltaX = this.menuGroup.getChildren()[0].displayWidth;

    this.overlay.width = this.scene.gameWidth;
    this.overlay.height = this.scene.gameHeight;
    this.overlay.setPosition(
      this.scene.getVisitedTableGameIndex() * this.overlay.width,
      0
    );

    Phaser.Actions.SetAlpha(this.menu.getChildren(), 0);

    this.overlay.setInteractive(
      new Phaser.Geom.Rectangle(
        0,
        0,
        this.overlay.displayWidth,
        this.overlay.displayHeight
      ),
      Phaser.Geom.Rectangle.Contains
    );
    this.overlay.on("pointerdown", this.overlayOnClick, this);
  }
  /**
   * @param width {number} table
   * @param height {number} table
   */
  reposition(width, height) {
    this.initX = this.scene.gameWidth * this.scene.getVisitedTableGameIndex();
    this.menuMargin = this.toggleButton.displayWidth / 2;
    this.toggleButton.setPosition(
      this.initX +
        this.scene.gameWidth -
        this.menuMargin -
        this.toggleButton.displayWidth,
      this.menuMargin
    );
    this.header.setPosition(
      this.initX -
        this.menuMargin +
        this.scene.gameWidth -
        this.header.displayWidth,
      this.menuMargin
    );
    this.closeButton.setPosition(
      this.header.x + this.header.displayWidth - this.header.displayHeight / 2,
      this.header.y + this.header.displayHeight / 2
    );

    let preChild;
    this.menuGroup.children.iterate((child) => {
      if (preChild)
        child.reposition(
          width,
          height,
          this.header.x,
          preChild.y + preChild.displayHeight * 0.99
        );
      else
        child.reposition(
          width,
          height,
          this.header.x,
          this.header.y + this.header.displayHeight * 0.99
        );
      preChild = child;
    }, this);
    this.overlay.setPosition(
      this.scene.getVisitedTableGameIndex() * this.overlay.width,
      0
    );
  }
  updatePositions() {
    this.initX = this.scene.gameWidth * this.scene.getVisitedTableGameIndex();
    this.overlay.setX(
      this.scene.getVisitedTableGameIndex() * this.overlay.width
    );
    this.header.setX(
      this.initX -
        this.menuMargin +
        this.scene.gameWidth -
        this.header.displayWidth
    );
    this.closeButton.setX(
      this.header.x + this.header.displayWidth - this.header.displayHeight / 2
    );
    this.menuGroup.children.iterate((child) => {
      child.updatePositions(this.header.x);
    }, this);
  }
}
